import React, { memo, useEffect, useState } from 'react';
import Pagination from '../../../../global/atoms/Pagination';
import { useAnalyticsContext } from '../../../../../config/GoogleTagManagerEvents';
import useMedia from '../../../../../hooks/useMedia';
import { VARIABLE_CONFIG } from '../../../../../constants/analyticsConstants/Variables';
import { usePageType } from '../../../../../hooks/usePageType';
import { logError } from '../../../../global/utils/logger';
import '../../../../../components/global/atoms/Pagination/pagination.scss';
import './pagination.scss';

const PageSelector = props => {
    const { controller } = props;
    const [paginationState, setPaginationState] = useState(controller.state);
    const mediaType = useMedia();
    const getPageRange = mediaType !== 'MOBILE' ? 5 : 3;
    const { sendEventsForClick } = useAnalyticsContext();
    const pageType = usePageType();

    const onStateChange = () => {
        const state = controller.state;
        setPaginationState(state);
    };

    useEffect(() => {
        controller.subscribe(onStateChange);
    }, []);
    const handlePageClick = ({ selected }, eventLabel) => {
        let page = pageType;
        if (pageType === VARIABLE_CONFIG.PAGE_TYPE.SEARCH_PAGE) {
            page = VARIABLE_CONFIG.ACTION.SEARCH;
        }
        if (
            eventLabel === VARIABLE_CONFIG.EVENT_LABEL.FIRST_PAGE_ICON ||
            eventLabel === VARIABLE_CONFIG.EVENT_LABEL.LAST_PAGE_ICON
        ) {
            try {
                sessionStorage.setItem('arrowClick', true);
                sendEventsForClick(
                    VARIABLE_CONFIG.EVENT.UAEVENT,
                    VARIABLE_CONFIG.ECOMMERCE.UNDEFINED,
                    VARIABLE_CONFIG.EVENT_CATEGORY.NAVIGATION,
                    VARIABLE_CONFIG.EVENT_ACTION.SELECT,
                    `${page} ${eventLabel}`
                );
            } catch (error) {
                logError(error, false, 'handleClick');
            }
        } else if (selected + 1 !== 0 && selected !== paginationState?.maxPage) {
            try {
                if (!sessionStorage.getItem('arrowClick')) {
                    sendEventsForClick(
                        VARIABLE_CONFIG.EVENT.UAEVENT,
                        VARIABLE_CONFIG.ECOMMERCE.UNDEFINED,
                        VARIABLE_CONFIG.EVENT_CATEGORY.NAVIGATION,
                        VARIABLE_CONFIG.EVENT_ACTION.SELECT,
                        `${page} ${selected + 1}`
                    );
                } else {
                    sessionStorage.removeItem('arrowClick');
                }
            } catch (error) {
                logError(error, false, 'handlePageClick');
            }
        }
        controller.selectPage(selected + 1);
        window.scrollTo(0, 0);
    };

    return (
        <Pagination
            maxPage={paginationState.maxPage}
            onPageChange={handlePageClick}
            currentPage={paginationState.currentPage}
            pageRangeDisplayed={getPageRange}
            marginPagesDisplayed={1}
        />
    );
};

export default memo(PageSelector);
